
import $ from "jquery";

$(document).ready(function() {
   $('.toggle-content').on('click', function() {
        $(this).closest('[data-block-parent="true"]').toggleClass('open-lines');
   });
});